<template>
  <div class="detail">
    <home-header></home-header>
    <personal-center></personal-center>
    <div class="content page-width">
      <div class="content-right pull-left">
        <a-spin :spinning="detailSpinning">
          <detail-list :list="list1" :article="article"></detail-list>
        </a-spin>
      </div>
      <div class="clearfix"></div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header';
import InsidePageLeft from '@/common/components/InsidePageLeft';
import Foot from '@/common/components/Foot';
import DetailList from './components/DetailList';
import PersonalCenter from '@/common/components/PersonalCenter';
import axios from 'axios';
export default {
  name: 'Index',
  components: {
    HomeHeader,
    Foot,
    DetailList,
    InsidePageLeft,
    PersonalCenter,
  },
  data: function() {
    return {
      list1: [],
      article: {},
      detailSpinning: true,
    };
  },
  methods: {
    getDetailInfo: function(url) {
      this.detailSpinning = true;
      this.axios
        .get(url, {
          params: {
            id: this.$route.params.id,
          },
        })
        .then(res => {
          if (res.success) {
            this.detailSpinning = false;
            this.article = res.result;
          }
        });
    },
    handleGetDataSucc: function(res) {
      res = res.data;
      if (res.ret && res.data) {
        const data = res.data;
        this.list1 = data.recommendList;
      }
    },
  },
  // mounted () {
  //   this.getDetailInfo()
  // },
  mounted() {
    if (this.$route.query.type === 'article') {
      this.getDetailInfo('/biz/article/detail');
    } else if (this.$route.query.type === 'notify') {
      this.getDetailInfo('/biz/home/notify/detail');
    } else {
      this.getDetailInfo('/biz/article/detail');
    }
  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.page-width {
  width: $pageWidth;
  margin: 0 auto;

  .content-right {
    margin-top: 30px;
    width:100%;
    overflow: hidden;

    .localtion {
      line-height: 30px;
      border-bottom: 1px solid $borderColor;
      margin-bottom: 20px;
    }
  }
}

.content-left {
  background: #f7f6f6;
}

.content {
  background: #fff;
  padding: 28px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.detail {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/detail/Index.vue